(() => {
  if (document.documentElement.dir !== 'rtl') return;

  const documents = new WeakSet();
  const frames = new WeakSet();

  function watchDocument(doc) {
    if (!doc || documents.has(doc)) return;
    documents.add(doc);

    function applyDirection() {
      if (doc.querySelector('#BISModal')) {
        doc.documentElement.setAttribute('dir', 'rtl');
      }
    }

    function inspect(node) {
      if (node.nodeType !== 1) return;
      if (node.matches('iframe')) watchFrame(node);
      node.querySelectorAll('iframe').forEach(watchFrame);
    }

    applyDirection();
    doc.querySelectorAll('iframe').forEach(watchFrame);

    new MutationObserver((mutations) => {
      applyDirection();
      mutations.forEach((mutation) => mutation.addedNodes.forEach(inspect));
    }).observe(doc.documentElement, { childList: true, subtree: true });
  }

  function watchFrame(frame) {
    if (frames.has(frame)) return;
    frames.add(frame);

    function onLoad() {
      // The browser only permits access to same-origin iframe documents.
      try {
        watchDocument(frame.contentDocument);
      } catch (error) {
        if (error.name !== 'SecurityError') throw error;
      }
    }

    frame.addEventListener('load', onLoad);
    onLoad();
  }

  watchDocument(document);
})();
